import React from "react";

export default function Searching(props) {
  return (
    <lottie-player
        src="https://assets2.lottiefiles.com/packages/lf20_FWh7bv.json"
        background="transparent"  speed="1"
        style={{width: '200px', height: '200px'}}  loop autoplay >
    </lottie-player>
  );
}
